import type { ReactNode } from 'react';
import type { PopoverOptions } from './context';
import { PopoverContext, usePopover } from './context';

// Export middleware functions from Floating UI
export {
  autoPlacement,
  arrow,
  flip,
  hide,
  inline,
  offset,
  shift,
  size,
} from '@floating-ui/react';

type PopoverProps = PopoverOptions & {
  /** The children of the popover. */
  children: ReactNode;
};

/**
 * Popover component.
 *
 * @type {React.FC<PopoverProps>}
 * @returns {React.ReactElement} The popover.
 * @example
 * import { Popover } from './Popover';
 */
export const Popover = ({ children, ...restOptions }: PopoverProps) => {
  const popover = usePopover(restOptions);
  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  );
};

Popover.displayName = 'Popover';
